import {
    Component,
    ContentChild,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

@Component({
    selector: 'app-labelled-block-input-wrapper',
    templateUrl: './labelled-block-input-wrapper.component.html',
    styleUrls: ['./labelled-block-input-wrapper.component.css'],
    standalone: false
})
export class LabelledBlockInputWrapperComponent implements OnInit {
    @ContentChild('wrapTarget', { static: true }) content: ElementRef;

    @Output() onFocus = new EventEmitter();
    @Output() onBlur = new EventEmitter();

    @Input() header: string = '';
    @Input() icon

    isFocused: boolean = false;

    ngOnInit(): void {
        if (this.content?.nativeElement) {
            this.content.nativeElement.addEventListener('focus', this.inputFocused.bind(this));
            this.content.nativeElement.addEventListener('blur', this.inputBlurred.bind(this));
        } else {
            console.warn(
                "Input label wrapper applied without a child element. Did you forget to add the '#wrapTarget' attribute to the input element?",
            );
        }
    }

    focusWrapTarget() {
        if (this.content?.nativeElement) {
            this.content.nativeElement.focus();
        }
    }

    inputFocused() {
        this.isFocused = true;
        this.emitFocus();
    }

    emitFocus() {
        this.onFocus.emit();
    }

    inputBlurred() {
        this.isFocused = false;
        this.emitBlur();
    }

    emitBlur() {
        this.onBlur.emit();
    }
}
